import React, { useContext, useEffect } from "react";
import { withRouter } from "react-router";
import { compose } from "redux";
import { Box } from "@mui/material";
import TodoList from "../TodoList/TodoList";
import { PropTypes } from "prop-types";
import SlideOutToDoListItem from "./SlideOutTodoListItem";
import { todoTypes } from "../../constants";
import UserAssignmentContext from "../../context/UserAssignmentContext";

function SlideOutTodoList({
  todoList,
  history,
  handleSlideOutClose,
  fetchTodos
}) {
  const { onStartAssignment, onResumeAssignment, isStarted } = useContext(
    UserAssignmentContext
  );

  useEffect(() => {
    fetchTodos();
  }, []);

  const handleOpenItem = (todoType, todoId, todoItem) => {
    switch (todoType) {
      case todoTypes.message:
        history.push({
          pathname: `/learning-center/messages/list`,
          state: { expandMessageId: todoId }
        });
        break;
      case todoTypes.assignment:
      case todoTypes.myCourses:
      case todoTypes.policy:
      case todoTypes.toDo:
        if (
          todoItem &&
          todoItem.enrolledTrainingObjectId &&
          isStarted(todoItem)
        ) {
          onResumeAssignment(todoItem);
        } else {
          onStartAssignment(todoItem);
        }
        break;
      default:
        return null;
    }
    handleSlideOutClose();
  };

  // we could consider removing the slice here since todoList is currently (5/23/2022) sent as 3 items already from the backend
  let todoListItems = todoList.slice(0, 3).map(todoItem => {
    return {
      ...todoItem,
      item: (
        <SlideOutToDoListItem {...todoItem} handleOpenItem={handleOpenItem} />
      )
    };
  });

  return (
    <React.Fragment>
      <Box pb={10}>
        <TodoList todoList={todoListItems} />
      </Box>
    </React.Fragment>
  );
}

SlideOutTodoList.propTypes = {
  todoList: PropTypes.arrayOf(PropTypes.any),
  user: PropTypes.any
};

export default compose(withRouter)(SlideOutTodoList);
